const BQ_CLICKED_GUEST_HOMEPAGE_CATEGORY_IMAGE = 'clicked_guest_homepage_category_image';
const BQ_CLICKED_HOMEPAGE_LO_SEARCH_TAG = 'clicked_homepage_lo_search_tag';
const BQ_CLICKED_HOMEPAGE_LO_GET_STARTED = 'clicked_homepage_lo_get_started';
const BQ_CLICKED_HOMEPAGE_LO_PRO_SERVICES = 'clicked_homepage_lo_pro_services';
const BQ_CLICKED_HOMEPAGE_LO_CARD_MADE_ON_FIVERR = 'clicked_homepage_lo_card_made_on_fiverr';

export {
    BQ_CLICKED_GUEST_HOMEPAGE_CATEGORY_IMAGE,
    BQ_CLICKED_HOMEPAGE_LO_SEARCH_TAG,
    BQ_CLICKED_HOMEPAGE_LO_GET_STARTED,
    BQ_CLICKED_HOMEPAGE_LO_PRO_SERVICES,
    BQ_CLICKED_HOMEPAGE_LO_CARD_MADE_ON_FIVERR
};
